import * as fromDatatype from '../datatype-library/index';

export interface bl_mlm_invitation_hdr_RowInterface {

    guid: fromDatatype.GuidDataFieldInterface;
    program_guid: fromDatatype.GuidDataFieldInterface;
    parent_participant_guid: fromDatatype.GuidDataFieldInterface;
    parent_entity_guid: fromDatatype.GuidDataFieldInterface;
    parent_member_guid: fromDatatype.GuidDataFieldInterface;
    child_entity_guid: fromDatatype.GuidDataFieldInterface;
    child_member_guid: fromDatatype.GuidDataFieldInterface;
    invitee_contact_guid: fromDatatype.GuidDataFieldInterface;
    lineage_type: fromDatatype.VarcharDatatypeInterface;
    invite_type: fromDatatype.VarcharDatatypeInterface;
    unique_code: fromDatatype.VarcharDatatypeInterface;
    invitee_email: fromDatatype.VarcharDatatypeInterface;
    invitee_phone: fromDatatype.VarcharDatatypeInterface;
    invite_status: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    expiry_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    channel_sms: fromDatatype.VarcharDatatypeInterface;
    channel_email: fromDatatype.VarcharDatatypeInterface;
    channel_whatsapp: fromDatatype.VarcharDatatypeInterface;
    channel_qrcode: fromDatatype.VarcharDatatypeInterface;
}

export class bl_mlm_invitation_hdr_RowClass implements bl_mlm_invitation_hdr_RowInterface {

    guid: fromDatatype.GuidDataFieldInterface;
    program_guid: fromDatatype.GuidDataFieldInterface;
    parent_participant_guid: fromDatatype.GuidDataFieldInterface;
    parent_entity_guid: fromDatatype.GuidDataFieldInterface;
    parent_member_guid: fromDatatype.GuidDataFieldInterface;
    child_entity_guid: fromDatatype.GuidDataFieldInterface;
    child_member_guid: fromDatatype.GuidDataFieldInterface;
    invitee_contact_guid: fromDatatype.GuidDataFieldInterface;
    lineage_type: fromDatatype.VarcharDatatypeInterface;
    invite_type: fromDatatype.VarcharDatatypeInterface;
    unique_code: fromDatatype.VarcharDatatypeInterface;
    invitee_email: fromDatatype.VarcharDatatypeInterface;
    invitee_phone: fromDatatype.VarcharDatatypeInterface;
    invite_status: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    expiry_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    channel_sms: fromDatatype.VarcharDatatypeInterface;
    channel_email: fromDatatype.VarcharDatatypeInterface;
    channel_whatsapp: fromDatatype.VarcharDatatypeInterface;
    channel_qrcode: fromDatatype.VarcharDatatypeInterface;
}
